import { render, staticRenderFns } from "./bQinZi_end.vue?vue&type=template&id=c9a20c8a&scoped=true&"
import script from "./bQinZi_end.vue?vue&type=script&lang=js&"
export * from "./bQinZi_end.vue?vue&type=script&lang=js&"
import style0 from "./bQinZi_end.vue?vue&type=style&index=0&id=c9a20c8a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9a20c8a",
  null
  
)

export default component.exports